import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", null, "All of your users will be synced with AccidentPlan.", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " Please specify which security clearances will grant users access to the admin portal. ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "The admin portal allows users to view accident reports.", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", null, "Security Groups", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("h5", null, "Allow these security groups to access AccidentPlan reports.", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Next")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode(_component_el_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_skeleton, {
          animated: "",
          loading: !_ctx.isLoadingSecGroups,
          throttle: 500
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_skeleton_item, {
                  variant: "rect",
                  style: {"width":"250px"}
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_skeleton_item, { variant: "button" })
              ]),
              _: 1
            })
          ]),
          template: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.selectedSecurityGroups,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedSecurityGroups = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.securityGroups, (securityGroup) => {
                      return (_openBlock(), _createBlock("div", {
                        key: securityGroup.id
                      }, [
                        _createVNode(_component_el_checkbox, {
                          label: securityGroup.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(securityGroup.name ??
                  _ctx.defaultSecurityGroupNames[securityGroup.id]), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _ctx.onNext,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ], 64))
}